<template>
  <PageWrapper
    :include-footer-gap="false"
    class="sm:pt-0 relative zindex-2"
  >
    <HomeNews />
    <HomeFavoriteProducts />
    <HomeArticles />
    <HomeReviews />
  </PageWrapper>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { defineAsyncComponent } from 'vue'

import PageWrapper from '@/components/general/BasePageWrapper.vue'
import HomeNews from '@/components/home/HomeNews.vue'
import useHead from '@/mixins/headManager'
import { useNavbarStore } from '@/stores/NavbarStore'

const HomeArticles = defineAsyncComponent(() => import('@/components/home/HomeArticles.vue'))
const HomeFavoriteProducts = defineAsyncComponent(() => import('@/components/home/HomeFavoriteProducts.vue'))
const HomeReviews = defineAsyncComponent(() => import('@/components/home/HomeReviews.vue'))

const { t } = useI18n()

const baseUrl = import.meta.env.VITE_VUE_APP_ORIGINAL_URL
const url = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl

const { setNavbar } = useNavbarStore()

setNavbar({
  backgroundColor: 'bg-primary-200',
  isHome: true,
  megaMenuId: 'homepage',
})

useHead({
  title: `${import.meta.env.VITE_VUE_APP_SITE_NAME + ': ' + t('title')}`,
  meta: [
    {
      property: `og:title`,
      content: `${import.meta.env.VITE_VUE_APP_SITE_NAME + ': ' + t('title')}`,
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: url,
    },
    {
      rel: 'alternate',
      hreflang: 'cs',
      href: 'https://www.mixit.cz/',
    },
    {
      rel: 'alternate',
      hreflang: 'sk',
      href: 'https://www.mixit.sk/',
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: 'https://www.mixit.pl/',
    },
    {
      rel: 'alternate',
      hreflang: 'hu',
      href: 'https://www.mixit.hu/',
    },
    {
      rel: 'alternate',
      hreflang: 'ro',
      href: 'https://www.mixit.ro/',
    },
  ],
})
</script>

<i18n>
  {
    "cs": {
    "title": "Kompletní nabídka jen u nás. Müsli, ovoce, čokoláda, oříšky"
},
    "sk": {
    "title": "Kompletná ponuka len u nás. Müsli, ovocie, čokoláda, oriešky"
},
    "pl": {
    "title": "Mixit.pl: Pełna oferta tylko u nas. Musli, owoce, czekolada, orzechy"
},
    "hu": {
    "title": "Teljes ajánlat csak nálunk. Müzli, gyümölcs, csokoládé, diófélék"
},
    "de": {
    "title": "Komplettes Angebot nur bei uns. Müsli, Früchte, Schoko, Nüsse"
},
    "at": {
    "title": "Komplettes Angebot nur bei uns. Müsli, Früchte, Schoko, Nüsse"
},
    "ro": {
    "title": "Ofertă completă numai la noi. Muesli, fructe, ciocolată, nuci"
}
  }
</i18n>
